import { useEffect } from 'react';
import { registerService } from '@shared/services/register';
import {
    extractErrorMessage,
    shouldBlockFetchError,
    showBlockingError,
} from '@shared/services/blockingError';

const STAFF_MOVEMENT_FETCH_OPTIONS = { blockingError: true };

export function useStaffMovementPermissionCheck() {
    useEffect(() => {
        let cancelled = false;

        const checkPermission = async () => {
            try {
                await registerService.getRegister({
                    page: 0,
                    pageSize: 1,
                    sortBy: 'empId',
                    sortDir: 'asc',
                });
            } catch (error) {
                if (!cancelled && shouldBlockFetchError(error, STAFF_MOVEMENT_FETCH_OPTIONS)) {
                    showBlockingError(extractErrorMessage(error));
                }
            }
        };

        checkPermission();

        return () => {
            cancelled = true;
        };
    }, []);
}

export function handleStaffMovementAccessError(error) {
    if (shouldBlockFetchError(error, STAFF_MOVEMENT_FETCH_OPTIONS)) {
        showBlockingError(extractErrorMessage(error));
        return true;
    }

    return false;
}
